import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ProdutoService } from '../produtos.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Produto, CategoriaComplemento, Complemento } from '../../../../models/produto/produto';
import { LoadingService } from '../../../../util/loader.service';
const swal = require('sweetalert');

@Component({
  selector: 'app-form-produtos',
  templateUrl: './form-produtos.component.html',
  styleUrls: ['./form-produtos.component.scss']
})
export class FormProdutosComponent implements OnInit {
  valForm: FormGroup;
  formComplemento: FormGroup;
  public onClose: Subject<any>;
  selectedTab = 1;
  categorias = [];
  categoria;
  produto: Produto;
  public record: any;
  categoriaComplemento: CategoriaComplemento;
  complemento: Complemento[] = new Array<Complemento>();
  expandedAll: boolean = true

  categoria_produto_edit_status: boolean;
  ingrediente_edit_status: boolean[];
  arr: FormArray;
  //formItemComplemento: FormGroup;

  constructor(public service: ProdutoService, private _bsModalRef: BsModalRef, public loader: LoadingService, public fb: FormBuilder) {
    this.produto = new Produto();
    this.produto.categoriaComplemento = Array<CategoriaComplemento>();
    this.categoriaComplemento = new CategoriaComplemento();


    this.valForm = this.fb.group({
      'produtoCategoria': [null, Validators.required],
      'produtoNome': [null, Validators.required],
      'produtoDescricao': [null, Validators.required],
      'produtoValor': [null, Validators.required]
    });

    this.formComplemento = fb.group({
      'formComplementoNome': [null, null],
      'formComplementoMin': [null, null],
      'formComplementoMax': [null, null],
      'produtoValor': [null, null],
      'formItemComplementoNome': [null, null],
      'formItemComplementoObrigatorio': [null, null],
      'formItemComplementoValor': [null, null],

    });

    /*this.formItemComplemento = fb.group({
      //arr: fb.array([this.createItem()])
    });*/

    this.carregarCaregoria();

    //var teste = this.formComplemento.get('arr');
  }
  expandeddAll() {
    this.expandedAll = !this.expandedAll;
    this.produto.categoriaComplemento.forEach(element => {
      element.expanded = this.expandedAll;
    });
  }
  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    this.service.cadastrarProduto(this.produto).subscribe(res => {
      this.loader.hide('body');

      if (res.success == true) {
        swal('Sucesso', 'Ação realizada com sucesso!', 'success');
        this.onClose.next(
          {
            sucesso: true
          }
        );
      }
      // this._bsModalRef.hide();

    });
  }


  carregarCaregoria() {
    this.service.listarCarregoria().subscribe((itens) => {
      // this.loader.hide("body");
      //this.page.count = itens.count;
      this.categorias = itens;

      // this.botoesAtivados = true;
    });
  }
  public onCancel(): void {
    const output = {
      sucesso: false
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }


  createItemComplemento() {
    return this.fb.group({
      'formItemComplementoNome': [null, null],
      'formItemComplementoObrigatorio': [null, null],
      'formItemComplementoValor': [null, null],
    })
  }

  add_categoria_produto() {
    if (this.categoriaComplemento.edit == true) {
      if (this.categoriaComplemento.id_categoria_complemento != undefined || this.categoriaComplemento.id_categoria_complemento != null) {
        ///MANDAR PRO SERVIDOR
        this.service.update_categoria_produto(this.categoriaComplemento).subscribe((response) => {
          this.update_item_util(this.produto.categoriaComplemento, this.categoriaComplemento);
          this.categoriaComplemento = null;
          this.categoriaComplemento = new CategoriaComplemento();
          this.categoria_produto_edit_status = false;
        });

      } else {
        this.update_item_util(this.produto.categoriaComplemento, this.categoriaComplemento);
        this.categoriaComplemento = null;
        this.categoriaComplemento = new CategoriaComplemento();
        this.categoria_produto_edit_status = false;
      }

    } else {
      if (this.produto.id_produto != undefined && this.produto.id_produto != null) {
        this.categoriaComplemento.id_produto = this.produto.id_produto;
        this.service.create_categoria_produto(this.categoriaComplemento).subscribe((response) => {
          if (response.id_categoria_complemento != null) {
            this.categoriaComplemento.referencia = this.uuidv4();
            this.categoriaComplemento.id_categoria_complemento = response.id_categoria_complemento;
            this.produto.categoriaComplemento.push(this.categoriaComplemento);
            this.categoriaComplemento = null;
            this.categoriaComplemento = new CategoriaComplemento();
          }
        });
      } else {
        this.categoriaComplemento.referencia = this.uuidv4();
        this.produto.categoriaComplemento.push(this.categoriaComplemento);
        this.categoriaComplemento = null;
        this.categoriaComplemento = new CategoriaComplemento();
      }
    }
  }

  editar_categoria_produto(record) {
    this.categoriaComplemento = record;
    this.categoriaComplemento.edit = true;
    this.categoria_produto_edit_status = true;
  }

  remove_categoria_produto(record, index) {
    swal({
      title: "Atenção",
      text: "Você tem certeza que gostaria de remover este registro?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Sim!",
      cancelButtonText: "Não!",
      closeOnConfirm: false,
      closeOnCancel: false
    }, (isConfirm) => {
      if (isConfirm) {
        if (record.id_categoria_complemento != undefined && record.id_categoria_complemento != null) {
          this.service.remover_categoria_produto(record.id_categoria_complemento).subscribe((response) => {
            if (response == 1) {
              this.remover_item_util(this.produto.categoriaComplemento, record);
              swal.close();
            }
          });
        } else {
          this.remover_item_util(this.produto.categoriaComplemento, record);
          swal.close();
        }
      } else {
        swal("Atenção", "Ação cancelada!", "success");
      }
    });
  }

  add_ingrediente_categoria_item(record, index) {
    if (record.complemento.edit) {
      if (record.complemento.id_complemento != null) {
        this.service.update_complemento_produto(record.complemento).subscribe((response) => {
          this.update_item_util(record.complementos, record.complemento);
          record.ingrediente_edit_status = false;
          record.complemento = null;
          record.complemento = new Complemento();
        });
      } else {
        this.update_item_util(record.complementos, record.complemento);
        record.ingrediente_edit_status = false;
        record.complemento = null;
        record.complemento = new Complemento();
      }

    } else {
      if (this.produto.id_produto != undefined && this.produto.id_produto != null) {
        record.complemento.id_categoria_complemento = record.id_categoria_complemento;
        this.service.create_complemento_produto(record.complemento).subscribe((response) => {
          if (response.id_complemento != null) {
            record.complemento.referencia = this.uuidv4();
            record.complemento.id_complemento = response.id_complemento;
            record.complementos.push(record.complemento);
            record.complemento = null;
            record.complemento = new Complemento();
          }
        });
      } else {
        record.complemento.referencia = this.uuidv4();
        record.complementos.push(record.complemento);
        record.complemento = null;
        record.complemento = new Complemento();
      }
    }
  }



  remover_item_util(arr, item) {
    for (var i = arr.length; i--;) {
      if (arr[i].referencia === item.referencia) {
        arr.splice(i, 1);

      }
    }
  }
  update_item_util(arr, data) {
    var item = {};
    if (arr.length > 0) {
      for (var index = 0; index < arr.length; index++) {
        if (arr[index].referencia == data.referencia) {
          arr[index] = data;
        }
      }
    }
    return item;
  }



  editar_ingrediente_categoria_item(index, categoria, item) {


    categoria.complemento = item;
      categoria.complemento.edit = true;
      categoria.ingrediente_edit_status = true;
  }

  expandedItem(item) {
    item.expanded = !item.expanded;

  }
  remove_ingrediente_categoria_item(index, categoria, item) {
    swal({
      title: "Atenção",
      text: "Você tem certeza que gostaria de remover este registro?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Sim!",
      cancelButtonText: "Não!",
      closeOnConfirm: false,
      closeOnCancel: false
    }, (isConfirm) => {
      if (isConfirm) {
        if (item.id_complemento != undefined) {
          this.service.remover_complemento_produto(item.id_complemento).subscribe((response) => {
            if (response == 1) {
              this.remover_item_util(categoria.complementos, item);
              swal.close();
            }
          });
        } else {
          swal.close();
          this.remover_item_util(categoria.complementos, item);
        }

      } else {
        //swal("Atenção", "Ação cancelada!", "success");
      }
    });
  }


  uuidv4(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  ngOnInit() {
    if (this.record !== undefined) {
      const auxProd = this.record as Produto;
      const newProd = new Produto();
      newProd.id_categoria = auxProd.id_categoria;
      newProd.id_produto = auxProd.id_produto;
      newProd.descricao = auxProd.descricao;
      newProd.status = auxProd.status;
      newProd.nome = auxProd.nome;
      newProd.valor = auxProd.valor;
      const listCategoriaComplemento = Array<CategoriaComplemento>();
      auxProd.categoriaComplemento.forEach(element => {
        const itemCategoria = new CategoriaComplemento();
        const listComplemento = new Array<Complemento>();
        itemCategoria.id_categoria_complemento = element.id_categoria_complemento;
        itemCategoria.nome = element.nome;
        itemCategoria.qnt_max = element.qnt_max;
        itemCategoria.qnt_min = element.qnt_min;
        itemCategoria.id_produto = auxProd.id_produto;

        itemCategoria.referencia = this.uuidv4();

        element.complementos.forEach(elementComplemento => {
          const comple = new Complemento();
          comple.id_complemento = elementComplemento.id_complemento;
          comple.nome = elementComplemento.nome;
          comple.obrigatorio = elementComplemento.obrigatorio;
          comple.valor = elementComplemento.valor;
          comple.referencia = this.uuidv4();
          listComplemento.push(comple);
        });
        itemCategoria.complementos = listComplemento;
        listCategoriaComplemento.push(itemCategoria);
      });
      newProd.categoriaComplemento = listCategoriaComplemento;
      this.produto = newProd;
    } else {
      this.produto = new Produto();
    }
    this.onClose = new Subject();
  }
}
